import { BasicRequest } from "./basicRequest";

export class TestPromptRequest extends BasicRequest{
    public instructions!:string; //the prompt of the AI step to test
    public moovDefinitionId?:number; //moov definition of the AI step; empty for a new, not yet saved definition (used for billing)
    public customerId?:number; //customer the definition is edited for; charged for tests of new definitions
    public outputFileDefinitionId?:number; //the test output must follow this file definition (like the apply file definition step after the AI step); empty = no layout

    constructor(){
        super();
    }
}
